"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERcrtCronTasks = exports.RCRT_SPORTS = exports.RCRT_SPORT_GENDERS = exports.RCRT_GENDERS = exports.ERcrtGenders = exports.ERcrtSports = exports.ERcrtActions = exports.loadAll = exports.olm = void 0;
/** Full NxtClick model, including EW-specific overrides. */
const model_core_1 = require("@nxt/model-core");
const model_core_2 = require("@nxt/model-core");
exports.olm = Object.assign({}, model_core_1.olm);
__exportStar(require("./src/Activity"), exports);
__exportStar(require("./src/College"), exports);
__exportStar(require("./src/Club"), exports);
__exportStar(require("./src/User"), exports);
__exportStar(require("./src/Event"), exports);
__exportStar(require("./src/Email"), exports);
__exportStar(require("./src/Collab"), exports);
__exportStar(require("./src/Share"), exports);
async function loadAll(parent, opts, stack, p) {
    opts = opts || {};
    opts.olm = opts.olm || exports.olm;
    await (0, model_core_2.loadAll)(parent, opts, stack, p);
}
exports.loadAll = loadAll;
var ERcrtActions;
(function (ERcrtActions) {
    ERcrtActions["VIEW"] = "views";
    ERcrtActions["PROFILE_VIEW"] = "pviews";
    ERcrtActions["PLAY"] = "plays";
    ERcrtActions["EMAIL"] = "emails";
    ERcrtActions["DRAFT"] = "draft";
    ERcrtActions["COMMENT"] = "comments";
    ERcrtActions["REACT"] = "react";
    ERcrtActions["SHARE"] = "shares";
    ERcrtActions["INTERNAL_LINK_CLICK"] = "internal";
    ERcrtActions["REPLIES"] = "replies";
    ERcrtActions["COLLAB"] = "collabs";
    ERcrtActions["VCARD"] = "card";
    ERcrtActions["CLICK"] = "clicks";
    ERcrtActions["EMAIL_FAILURE"] = "email_err";
})(ERcrtActions || (exports.ERcrtActions = ERcrtActions = {}));
var ERcrtSports;
(function (ERcrtSports) {
    ERcrtSports["SOCCER"] = "soccer";
    ERcrtSports["NONE"] = "";
})(ERcrtSports || (exports.ERcrtSports = ERcrtSports = {}));
var ERcrtGenders;
(function (ERcrtGenders) {
    ERcrtGenders["MEN"] = "men";
    ERcrtGenders["WOMEN"] = "women";
})(ERcrtGenders || (exports.ERcrtGenders = ERcrtGenders = {}));
exports.RCRT_GENDERS = [
    {
        label: 'Women',
        value: ERcrtGenders.WOMEN
    },
    {
        label: 'Men',
        value: ERcrtGenders.MEN
    }
];
exports.RCRT_SPORT_GENDERS = [
    {
        label: `Women's Soccer`,
        value: { gender: ERcrtGenders.WOMEN, sport: ERcrtSports.SOCCER }
    },
    {
        label: `Men's Soccer`,
        value: { gender: ERcrtGenders.MEN, sport: ERcrtSports.SOCCER }
    }
];
exports.RCRT_SPORTS = [
    {
        label: 'Soccer',
        value: ERcrtSports.SOCCER
    },
    {
        label: 'Others Coming Soon!',
        value: ''
    }
];
var ERcrtCronTasks;
(function (ERcrtCronTasks) {
    ERcrtCronTasks["SPORT_IMPORT"] = "RCRT.importSport";
    ERcrtCronTasks["SPORT_ADD"] = "RCRT.addSport";
    ERcrtCronTasks["STAFF_UPDATE_TRIGGER"] = "RCRT.staffUpdateTrigger";
    ERcrtCronTasks["STAFF_UPDATE"] = "RCRT.updateStaff";
    ERcrtCronTasks["SEASON_UPDATE_TRIGGER"] = "RCRT.seasonUpdateTrigger";
    ERcrtCronTasks["EVENT_IMPORT_TRIGGER"] = "RCRT.eventImportTrigger";
    ERcrtCronTasks["SEASON_UPDATE"] = "RCRT.updateSeason";
    ERcrtCronTasks["EVENT_IMPORT"] = "RCRT.importEvent";
    ERcrtCronTasks["CLUB_IMPORT_MEMBERS"] = "RCRT.importClubMembers";
    ERcrtCronTasks["PLAYER_IMPORT"] = "RCRT.importRoster";
    ERcrtCronTasks["PLAYER_UPDATE_TRIGGER"] = "RCRT.playerUpdateTrigger";
    ERcrtCronTasks["PLAYER_EMAIL_WATCH"] = "RCRT.playerEmailWatch";
})(ERcrtCronTasks || (exports.ERcrtCronTasks = ERcrtCronTasks = {}));
